/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Text } from "vr-react-components";
import { MathUtils } from "three";

const Player = ({ intersectClasses, playerID, sound, ...otherAttributes }) => {
    const participants = useSelector((state) => state.room.participants)

    const user = participants.find((participant) => participant.socketId === playerID)
    const userIndex = participants.findIndex((participant) => participant.socketId === playerID);

    let position = user?.position || { x: userIndex, y: 1.6, z: 0 };
    let hands = user?.hands || {};
    let rotation = user?.rotation || "0 0 0";
    let name = user?.username || "Guest";
    let line = {};
    if (position) {
        if (position.x != null) {
            line.start = position.x + " " + (position.y - 0.35) + " " + position.z;
            position = position.x + " " + position.y + " " + position.z;
        }
        if (rotation._x != null) {
            rotation =
                MathUtils.radToDeg(rotation._x) +
                " " +
                MathUtils.radToDeg(rotation._y) +
                " " +
                MathUtils.radToDeg(rotation._z);
        }
        if (hands.end) {
            line.end = hands.end.x + " " + hands.end.y + " " + hands.end.z;
        }
    }

    return (
        <a-entity class="Player" {...otherAttributes}>
            <a-entity position={position} rotation={rotation}>
                <Text
                    side="double"
                    align="center"
                    position="0 0.7 0"
                    rotation={rotation}
                    text={name}
                    width={1}
                    sizeDecimal={10}
                />
                <a-entity
                    position="-0.05 -1 0"
                    rotation="0 180 0"
                    scale="0.75 0.75 0.75"
                >
                    <a-obj-model
                        shadow=""
                        rotation="0 0 0"
                        src="#player-obj"
                        mtl="#player-mtl"
                    />
                </a-entity>
            </a-entity>
            {Object.keys(hands).length > 0 ? (
                <a-entity
                    id={"player-hand-" + playerID}
                    line={"start:" + line.start + "; end:" + line.end + "; color: cyan"}
                    raycaster={"objects: " + intersectClasses}
                    sound={"src: #" + playerID}
                />
            ) : null}
        </a-entity>
    );
};

export default Player;